import {RoomModel} from "./room.model";
import {MapDimensionsModel} from "./map-dimensions.model";

export class RoomContainerModel {
  id: number = new Date().getTime();
  name: string = 'Épület/szint';
  mapDimensions: MapDimensionsModel = new MapDimensionsModel();
  rooms: RoomModel[] = [];
}
